import { render, staticRenderFns } from "./thePaper.vue?vue&type=template&id=4d759abb&scoped=true&"
import script from "./thePaper.vue?vue&type=script&lang=js&"
export * from "./thePaper.vue?vue&type=script&lang=js&"
import style0 from "./thePaper.vue?vue&type=style&index=0&id=4d759abb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d759abb",
  null
  
)

export default component.exports